<div class="p-6 md:p-12 lg:pt-20 !pb-0 container mx-auto">
    <div class="grid grid-cols-12 gap-4" data-aos="fade-up"  data-aos-delay="300">
        <div class="col-span-12 md:col-span-12">
            <div class="relative text-center"  >
                <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink top-16 left-32 w-10 h-10" alt="">
                <h2 class="text__grey--gradient text-4xl sm:text-5xl md:text-7xl lg:text-8xl xl:text-9xl mi--font-regular">Upcoming</h2>
                <p class="text__yg--gradient text-base sm:text-2xl lg:text-3xl xl:text-4xl mi--font-regular absolute bottom-0 inset-x-8 lg:inset-x-20">What’s  next  for  BX  Finance?</p>
                <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink bottom-16 right-32 w-10 h-10" alt="">
            </div>
        </div>
    </div>
    <div class="grid grid-cols-12 gap-0 md:gap-8 pt-8 lg:py-12">
        <!-- <div class="col-span-12 md:col-span-6">
            <div class="grid grid-cols-12 gap-4">
                <div class="col-span-4 upcoming">
                    <img src="assets/landing-new/icons/upcoming/1.png" class="w-20 h-20 lg:!w-32 lg:h-32 animate--float" alt="">
                </div>
                <div class="col-span-4 upcoming">
                    <img src="assets/landing-new/icons/upcoming/2.png" class="w-20 h-20 lg:!w-32 lg:h-32 animate--float" alt="">
                </div>
                <div class="col-span-4 upcoming">
                    <img src="assets/landing-new/icons/upcoming/3.png" class="w-20 h-20 lg:!w-32 lg:h-32 animate--float" alt="">
                </div>
            </div>
        </div> -->
        <div class="col-span-12" data-aos="fade-up"  data-aos-delay="400">
            <p class="text-[#D9D9D9] text-sm text-center md:text-base lg:text-lg ep--font-light">Unlike it’s counterparts, you don’t have to trust just an idea with BX Finance. Our no code web3 platform will be ready to use from day one, even if you don’t hold our utility token. However, our ecosystem is going to expand even further.</p>
            <!-- <p class="text__yg--gradient text-sm md:text-base xl:text-lg mi--font-regular font-normal mt-4"><img src="assets/landing-new/icons/star-yellow.svg" class="inline animate-blink w-12 h-12 pr-2" alt="">Here’s how.</p>  -->
        </div>
    </div>
</div>
